// Base Validator Interface
import {type MessageParams, type ValidatorResult} from "../types";

export abstract class BaseValidator {
    protected readonly _message: string;
    protected readonly _messageParams?: MessageParams;

    protected constructor(message: string, messageParams?: MessageParams) {
        this._message = message;
        this._messageParams = messageParams;
    }

    get message(): string {
        return this._message;
    }

    get messageParams(): MessageParams | undefined {
        return this._messageParams;
    }

    abstract validate(value: string): ValidatorResult;

    // Helper method
    protected success(): ValidatorResult {
        return {isValid: true};
    }

    protected fail(error?: string, errorParams?: MessageParams): ValidatorResult {
        return {
            isValid: false,
            error: error || this._message,
            errorParams: errorParams || this._messageParams,
        };
    }
}
